export const parseAllEdificios = (data) => {
   return data.map(d => {
        return {...d, conEstacionamiento: d.conEstacionamiento.data[0] ? 1 : 0}
    })
} 
